class FirehawkCheckout {

	cartId = null
	checkoutWrapper = null;
	addressAutoComplete = null;

	paymentIntent = null;
	ddPaymentIntent = null
	paymentElement = null;
	elements = null;

	formElement = null
	isSubmitting = false
	submittingOrder = false
	paymentFormComplete = false
	checkoutComplete = false;
	countries = null;

	paymentProviderApiKey = null;

	paymentMethod = null
	loadingPaymentProvider = true
	hasSetupPaymentProvider = false

	hasInjectedPaymentScript = false
	hasInjectedPaymentStyles = false

	cartCurrency = "usd"
	useTestPayments = false
	stripe = null

	paymentProvider = "stripe"
	channel = null;

	isRefreshingPaymentForm = false;

	currentShippingOptions = null;
	scriptInjector = null

	AdyenVersion = "6.28.0"
	scriptInjectState = null
	styleInjectState = null
	adyenClientKey = "test_W3LZRR3QZFFTBFGQV4W6KWN5QQ276EKP"

	paymentPlanSelected = null
	paymentPlans = null

	depositAmount = null
	planDepositDisplay = "no"
	depositDebounce = null
	adyenDropinComponent = null
	adyenCheckout = null

	successRedirectUrl = null
	successNoRedirect = false
	useCustomConfirmationPage = false
	payByInstallments = false

	requestObserver = null

	ddSubmitFallbackTimeout = null

	nabForm = null
	hasRetriedSetup = false
	hasRetriedIntent = false
	nabCaptureContext = null

	constructor(cartId, element, countries = null, provderApiKey = null, cartCurrency = null, paymentProvider = "stripe", useTestPayments = false, demoMode = false, paymentPlans = [], nabCaptureContext = null) {
		this.countries = countries;
		this.cartId = cartId && cartId.length ? cartId : null
		this.checkoutWrapper = element
		this.formElement = jQuery(this.checkoutWrapper).find("form")
		this.paymentProviderApiKey = provderApiKey && provderApiKey.length ? provderApiKey : null;
		this.paymentProvider = paymentProvider
		this.demoMode = demoMode
		this.paymentPlans = paymentPlans;
		if (cartCurrency && cartCurrency.length) {
			this.cartCurrency = cartCurrency;
		}
		this.useTestPayments = useTestPayments || false;
		this.addListeners()
		this.setupGoogleAddress();

		this.scriptInjector = new FirehawkScriptInject()

		this.refreshPaymentForm()
	}

	refreshPaymentForm() {
		if (this.paymentProvider == "adyen") {
			this.setupAdyen()
			this.observeAdyenCheckout()
		} else if (this.paymentProvider == "nab-gateway") {
			this.nabCaptureContext = nabCaptureContext;
			this.setupNabGateway();
		} else {
			this.setupStripe();
		}
	}

	addListeners() {
		window.addEventListener('beforeunload', (e) => {
			if (!this.checkoutComplete && this.submittingOrder) {
				// Cancel the event
				e.preventDefault(); 
				// Chrome requires returnValue to be set
				e.returnValue = ''; 
			}
		});

		jQuery(this.checkoutWrapper).delegate("#submit-order", 'click', (event) => {
			event.preventDefault()
			if (this.demoMode) return

			if (this.paymentProvider == "nab-gateway") {
				this.submitNabGatewayCheckout()
			} else {
				this.submitOrder();
			}
		});

		this.formElement.validate({
			// Specify validation rules
			rules: {
				// The key name on the left side is the name attribute
				// of an input field. Validation rules are defined
				// on the right side
				shippingFirstName: {
					required: true
				},
				shippingLastName: {
					required: true
				},
				shippingStreet: {
					required: true
				},
				shippingCity: {
					required: true
				},
				shippingState: {
					required: true
				},
				shippingPostcode: {
					required: true
				},
				shippingEmail: {
					required: true,
					email: true
				}
			},
			// Specify validation error messages
			messages: {
				shippingFirstName: "Please enter your first name",
				shippingLastName: "Please enter your last name",
				shippingStreet: "Please enter in a street address",
				shippingCity: "Please enter in a city",
				shippingState: "Please enter in a state",
				shippingPostcode: "Please enter in a zip code",
				shippingEmail: "Please enter a valid email address"
			},
			// Make sure the form is submitted to the destination defined
			// in the "action" attribute of the form when valid
			// submitHandler: function(form) {
			//   form.submit();
			// }
		});

		jQuery(this.checkoutWrapper).delegate("input[type=text][name=shippingPostcode], select[name=shippingState], select[name=shippingCountry]", 'change', (event) => {
			event.preventDefault();
			this.updateAvailableShippingMethods();
		});

		jQuery(this.checkoutWrapper).delegate("input[type=radio][name=shippingOption]", 'change', (event) => {
			event.preventDefault();
			let current = jQuery(event.currentTarget);
			let optionSelected = jQuery(current).val();
			this.updateShippingMethod(optionSelected);
		});

		jQuery(this.checkoutWrapper).delegate("input[type=radio][name=paymentOption]", 'change', (event) => {
			event.preventDefault();
			let current = jQuery(event.currentTarget);
			let optionSelected = jQuery(current).val();
			this.updatePaymentMethod(optionSelected);
		});

		jQuery(this.checkoutWrapper).delegate("input[type=radio][name=paymentPlanOption]", 'change', (event) => {
			event.preventDefault();
			let current = jQuery(event.currentTarget);
			let optionSelected = jQuery(current).val();
			this.updatePaymentPlan(optionSelected);
		});

		jQuery(this.checkoutWrapper).delegate("input[type=radio][name=paymentPlanDepositOption]", 'change', (event) => {
			event.preventDefault();
			let current = jQuery(event.currentTarget);
			let optionSelected = jQuery(current).val();
			this.updatePaymentPlanDepositDisplay(optionSelected);
		});

		jQuery(this.checkoutWrapper).delegate("input[type=radio][name=paymentPlanInstalmentOption]", 'change', (event) => {
			event.preventDefault();
			let current = jQuery(event.currentTarget);
			let optionSelected = jQuery(current).val();
			this.updatePaymentInstalment(optionSelected);
		});

		jQuery(this.checkoutWrapper).delegate("#refresh-payment-form", 'click', (event) => {
			event.preventDefault();
			if (this.isRefreshingPaymentForm) {
				return;
			}

			if (this.paymentProvider == "adyen") {
				this.isRefreshingPaymentForm = true;
				this.setupAdyen()
			}
		});

		jQuery(this.checkoutWrapper).delegate("#depositAmount", "keyup", (event) => {
			this.query = event.currentTarget.value;
			if (this.depositDebounce) clearTimeout(this.depositDebounce);

			this.depositDebounce = setTimeout(() => {
				this.runUpdateInstalments();
			}, 500)
		})

		var paymentOption = jQuery(this.checkoutWrapper).find("input[type=radio][name=paymentOption]:checked")
		this.updatePaymentMethod(paymentOption.val())

		var paymentPlanOption = jQuery(this.checkoutWrapper).find("input[type=radio][name=paymentPlanOption]:checked")
		if (paymentPlanOption.val()) this.updatePaymentPlan(paymentPlanOption.val())

		jQuery(this.checkoutWrapper).delegate("select[name=shippingCountry]", 'change', (event) => {
			event.preventDefault();
			let current = jQuery(event.currentTarget);
			let optionSelected = jQuery(current).val();

			if (optionSelected && optionSelected.length) {
				let foundCountry = this.countries.find((c) => c && c.name == optionSelected)

				if (foundCountry && foundCountry["alpha-2"] && this.addressAutoComplete) {
					this.addressAutoComplete.setComponentRestrictions({
						'country': foundCountry["alpha-2"]
					})
				} else if (this.addressAutoComplete) {
					this.addressAutoComplete.setComponentRestrictions({
						'country': null
					})
				}

				jQuery.ajax({
					method: 'post',
					url: ajax_var.url,
					data: {
						action: 'fh_fetch_states',
						params: {
							country: foundCountry.id || null
						}
					}
				}).done((res) => {
					let response = JSON.parse(res);

					let pickerField = jQuery(this.checkoutWrapper).find("select[name=shippingState]");
					let inputField = jQuery(this.checkoutWrapper).find("input[name=shippingState]");
					pickerField.empty();

					if (response && response.result && response.result.length) {
						// Show select field
						pickerField.show()
						pickerField.parent().show()

						// Hide input field
						inputField.hide()
						inputField.parent().hide()
						inputField.val('')

						for (let state of response.result) {
							let option = jQuery("<option></option>")
								.attr("value", state.name).text(state.name)
							pickerField.append(option)
						}
					} else {
						// Hide select field
						pickerField.hide()
						pickerField.parent().hide()

						// Show input field
						inputField.show()
						inputField.parent().show()
					}
				});
			}
			// this.updateShippingMethod(optionSelected);
		});

	}

	updateAvailableShippingMethods() {

		let shippingCity = jQuery(this.checkoutWrapper).find('input[name="shippingCity"]').val()
		let shippingCounty = jQuery(this.checkoutWrapper).find('input[name="shippingCounty"]').val()
		let shippingState = jQuery(this.checkoutWrapper).find('select[name="shippingState"]').val()
		let shippingPostcode = jQuery(this.checkoutWrapper).find('input[name="shippingPostcode"]').val()
		let shippingCountry = jQuery(this.checkoutWrapper).find('select[name="shippingCountry"]').val()

		let address = {
			city: shippingCity || null,
			county: shippingCounty || null,
			state: shippingState || null,
			postcode: shippingPostcode || null,
			country: shippingCountry || null
		}

		console.log("address", address)

		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'fh_cart_shipping_update',
				params: address
			}
		}).done((res) => {
			let response = JSON.parse(res);
			if (response && response['result'] && response['result'].length) {
				let updateList = false;
				if (!this.currentShippingOptions) {
					this.currentShippingOptions = response['result'];
				} else {
					for (let i = 0; i < response['result'].length; i++) {
						const el = response['result'][i];
						if (!this.currentShippingOptions.find((c) => c.id == el.id)) {
							this.currentShippingOptions.push(el);
						} else {
							if (this.currentShippingOptions.find((c) => c.id == el.id).priceExclTax != el.priceExclTax) {
								this.currentShippingOptions.find((c) => c.id == el.id).priceExclTax = el.priceExclTax;
								this.currentShippingOptions.find((c) => c.id == el.id).priceInclTax = el.priceInclTax;
								this.currentShippingOptions.find((c) => c.id == el.id).tax = el.tax;
								this.currentShippingOptions.find((c) => c.id == el.id).name = el.name;
								updateList = true;
							}
						}
					}
				}
				let newShippingOptions = "";
				console.log("this.currentShippingOptions", this.currentShippingOptions)
				for (let i = 0; i < response['result'].length; i++) {
					const el = response['result'][i];
					let item = `<div class="list-group-item">
						<div class="form-check mb-0">
						<input class="form-check-input" type="radio" name="shippingOption" id="${el.id}" value="${el.id}">
						<label class="form-check-label" for="${el.id}">
							${el.name}
						</label>
						</div>
					</div>`

					newShippingOptions += item;
					console.log(newShippingOptions)
					jQuery('.shipping-method-list').html(newShippingOptions);
				}
			}
		}).fail((xhr, status, error) => {
			console.log(status, error)
		})
	}

	setupGoogleAddress() {

		let element = document.getElementById("shippingStreet");

		if (!element) return;

		this.addressAutoComplete = new google.maps.places.Autocomplete(element);

		let shippingCountry = jQuery(this.checkoutWrapper).find('select[name="shippingCountry"]').val()
		let foundCountry = this.countries.find((c) => c && c.name == shippingCountry)

		if (foundCountry && foundCountry["alpha-2"]) {
			this.addressAutoComplete.setComponentRestrictions({
				'country': foundCountry["alpha-2"]
			})
		} else {
			this.addressAutoComplete.setComponentRestrictions({
				'country': ["US"]
			})
		}

		var googleListener = this.addressAutoComplete.addListener('place_changed', this.handleGoogleAddress.bind(this))
	}

	handleGoogleAddress() {
		var place = this.addressAutoComplete.getPlace()

		if (!place) return;

		var addressComponents = place["address_components"] || {}

		var city = this.findGoogleAddressPart(addressComponents, ['locality', 'sublocality', 'postal_town'], 'long_name') || ""
		var stateShort = this.findGoogleAddressPart(addressComponents, 'administrative_area_level_1', 'short_name') || ""
		var stateLong = this.findGoogleAddressPart(addressComponents, 'administrative_area_level_1', 'long_name') || ""
		var countyShort = this.findGoogleAddressPart(addressComponents, 'administrative_area_level_2', 'short_name') || ""
		var countyLong = this.findGoogleAddressPart(addressComponents, 'administrative_area_level_2', 'long_name') || ""
		var postcode = this.findGoogleAddressPart(addressComponents, 'postal_code', 'long_name') || ""
		var country = this.findGoogleAddressPart(addressComponents, 'country', 'long_name') || ""

		jQuery(this.checkoutWrapper).find("input[id='shippingCity']").val(city)

		var statePicker = jQuery('select[name="shippingState"]');
		var stateField = jQuery('input[name="shippingState"]');

		if (statePicker.length > 0 && statePicker.is('select')) {
			jQuery(statePicker).find("option").each(function () {
				this.selected = (this.text == stateLong);
			});
			if (jQuery(statePicker).data("select2")) {
				jQuery(statePicker).select2("data", {
					id: stateLong,
					text: stateShort
				})
				jQuery(statePicker).trigger('change')
			}
		} else if (stateField.length > 0) {
			stateField.val(stateShort)
		}

		jQuery(this.checkoutWrapper).find("input[id='shippingCounty']").val(countyShort || countyLong);
		jQuery(this.checkoutWrapper).find("input[id='shippingPostcode']").val(postcode);
		jQuery(this.checkoutWrapper).find("select[id='shippingCountry'] option").each(function () {
			this.selected = (this.text == country);
		});

		var subpremise = this.findGoogleAddressPart(addressComponents, 'subpremise', 'long_name') || ""
		var streetNumber = this.findGoogleAddressPart(addressComponents, 'street_number', 'long_name') || ""
		var street = this.findGoogleAddressPart(addressComponents, 'route', 'long_name') || ""

		var fullStreetNumber;
		if (subpremise && streetNumber) {
			fullStreetNumber = `${subpremise}/${streetNumber}`
		} else if (streetNumber) {
			fullStreetNumber = streetNumber
		}

		var line1 = "";

		if (fullStreetNumber && street) {
			line1 = `${fullStreetNumber} ${street}`
		} else if (street) {
			line1 = street
		}
		jQuery(this.checkoutWrapper).find("input[id='shippingStreet']").val(line1)

		this.formElement.valid()
	}

	findGoogleAddressPart(address_components, query, val = null) {
		for (let attr of address_components) {
			for (let type of attr.types) {
				if (Array.isArray(query) && query.filter(q => q == type).length > 0) {
					return val ? attr[val] : attr;
				} else if (type === query) {
					return val ? attr[val] : attr;
				}
			}
		}
		return null;
	}

	checkFormValid() {
		if (!this.formElement.valid()) {
			return false
		}

		return true;
	}

	updateSubmitButton(status) {
		jQuery("#submit-order").prop('disabled', status);
	}

	submitOrder(intent = true, paymentId = null) {
		if (this.demoMode) return;
		if (this.isSubmitting) return;

		var errorView = jQuery(this.checkoutWrapper).find("#submit-error")
		var submitButton = jQuery(this.checkoutWrapper).find("#submit-order")

		submitButton.addClass("loading")

		if (!this.checkFormValid()) {
			//TODO: Show form error;
			errorView.html("Please fill out the required form fields before submitting")
			errorView.removeClass("d-none")
			submitButton.removeClass("loading")
			return;
		}

		if (!this.paymentFormComplete) {
			errorView.html("Please fill out the required payment details before submitting")
			errorView.removeClass("d-none")
			submitButton.removeClass("loading")
			return
		}

		errorView.addClass("d-none")

		const submitOrderToCRM = () => {
			let shippingFirstName = jQuery(this.checkoutWrapper).find('input[name="shippingFirstName"]').val()
			let shippingLastName = jQuery(this.checkoutWrapper).find('input[name="shippingLastName"]').val()
			let shippingCompany = jQuery(this.checkoutWrapper).find('input[name="shippingCompany"]').val()
			let shippingStreet = jQuery(this.checkoutWrapper).find('input[name="shippingStreet"]').val()
			let shippingCity = jQuery(this.checkoutWrapper).find('input[name="shippingCity"]').val()
			let shippingPickerState = jQuery(this.checkoutWrapper).find('select[name="shippingState"]').val()
			let shippingFieldState = jQuery(this.checkoutWrapper).find('input[name="shippingState"]').val()
			let shippingCounty = jQuery(this.checkoutWrapper).find('input[name="shippingCounty"]').val()
			let shippingCountry = jQuery(this.checkoutWrapper).find('select[name="shippingCountry"]').val()
			let shippingPostcode = jQuery(this.checkoutWrapper).find('input[name="shippingPostcode"]').val()
			let shippingEmail = jQuery(this.checkoutWrapper).find('input[name="shippingEmail"]').val()
			let shippingPhone = jQuery(this.checkoutWrapper).find('input[name="shippingPhone"]').val()

			let params = {
				cart: this.cartId,
				orderDetails: {
					shippingFirstName: shippingFirstName || null,
					shippingLastName: shippingLastName || null,
					shippingCompany: shippingCompany || null,
					shippingStreet: shippingStreet || null,
					shippingCity: shippingCity || null,
					shippingState: shippingPickerState || shippingFieldState || null,
					shippingCounty: shippingCounty || null,
					shippingCountry: shippingCountry || null,
					shippingPostcode: shippingPostcode || null,
					shippingEmail: shippingEmail || null,
					shippingPhone: shippingPhone || null
				},
				paymentIntent: this.paymentIntent || null,
				paymentProvider: this.paymentProvider || null,
				paymentId: paymentId
			};

			jQuery.ajax({
				method: 'post',
				url: ajax_var.url,
				data: {
					action: 'submit_order',
					params: params
				}
			}).done((res) => {
				this.paymentSuccessRedirect(res)
				submitButton.removeClass("loading")
			}).fail((xhr, status, error) => {
				console.error("Error", error)
				errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
				errorView.removeClass("d-none")
				submitButton.removeClass("loading")
				this.isSubmitting = false
			})
		}

		if (!intent) {
			submitOrderToCRM()
			return
		}

		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'fh_pay_run_total_check',
				params: {
					paymentIntent: this.paymentIntent,
					cart: this.cartId
				}
			}
		}).done((resC) => {

			let totalCheckRes = JSON.parse(resC);

			if (!totalCheckRes || !totalCheckRes.result) {
				console.log("its different")
				return
			}

			let eles = this.elements;

			this.stripe.confirmPayment({
				elements: eles,
				redirect: "if_required",
			}).then((result) => {
				if (result.error) {
					// Inform the customer that there was an error.
					console.error("Error", error)
					errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
					errorView.removeClass("d-none")
					submitButton.removeClass("loading")
					this.isSubmitting = false
					return;
				}

				submitOrderToCRM();
			}).catch((error) => {
				console.error("Error", error)
				errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
				errorView.removeClass("d-none")
				submitButton.removeClass("loading")
				this.isSubmitting = false
			})
		}).fail((xhr, status, error) => {
			console.error("Error", error)
			errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
			errorView.removeClass("d-none")
			submitButton.removeClass("loading")
			this.isSubmitting = false
		})
	}

	setupNabGateway() {

		this.loadingPaymentProvider = true

		if (!this.hasSetupPaymentProvider) {
			jQuery(this.checkoutWrapper).find("#fh-payment-details").hide()
			jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").show()
		}

		let params = {
			paymentProvider: "nab-gateway"
		};

		if (this.cartId && this.cartId.length) {
			params.cart = this.cartId
		}

		if (this.useTestPayments) {
			params.testPayment = true;
		}

		if (this.nabCaptureContext) {
			this.paymentIntent = this.nabCaptureContext;
			this.configureNabGateway(this.nabCaptureContext);
		}
		this.loadingPaymentProvider = false
	}

	configureNabGateway(paymentIntent) {
		this.paymentIntent = paymentIntent

		// custom styles that will be applied to each field we create using Microform
		var myStyles = {
			'input': {
				'font-size': '14px',
				'font-family': 'helvetica, tahoma, calibri, sans-serif',
				'color': '#555'
			},
			':disabled': { 'cursor': 'not-allowed' },
			'invalid': { 'color': '#a94442' }
		};


		jQuery(this.checkoutWrapper).find("#fh-payment-details").show()
		jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").hide()
		// setup
		var flex = new Flex(paymentIntent);
		this.nabForm = flex.microform({ styles: myStyles });
		var number = this.nabForm.createField('number', { placeholder: 'Enter card number' });
		var securityCode = this.nabForm.createField('securityCode', { placeholder: '•••' });

		number.load('#number-container');
		securityCode.load('#securityCode-container');

		this.loadingPaymentProvider = false
	}

	submitNabGatewayCheckout() {
		var options = {
			expirationMonth: document.querySelector('#expMonth').value,
			expirationYear: document.querySelector('#expYear').value
		};
		const formValues = this.collectFormValuesNAB('.fh-checkout-details form');

		let params = {
			paymentProvider: "nab-gateway",
			currency: this.cartCurrency,
			...formValues,
		};

		if (this.cartId && this.cartId.length) {
			params.cart = this.cartId
		}

		if (this.useTestPayments) {
			params.testPayment = true;
		}
		var errorView = jQuery(this.checkoutWrapper).find("#submit-error")
		var submitButton = jQuery(this.checkoutWrapper).find("#submit-order")
		const me = this;
		submitButton.addClass("loading")

		this.nabForm.createToken(options, function (err, token) {
			if (err) {
				// handle error
				console.error(err);
				errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
				errorView.removeClass("d-none")
				submitButton.removeClass("loading")
			} else {
				params.token = token;
				jQuery.ajax({
					method: 'post',
					url: ajax_var.url,
					data: {
						action: 'fh_pay_intent_results',
						params: params
					}
				}).done((response) => {
					const res = JSON.parse(response);
					if (res.status == 200 || res.status == 201) {
						me.paymentFormComplete = true;

						if (res.error || res.errors) {
							const error = res.error || res.errors
							console.error("Error", error)
							errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
							errorView.removeClass("d-none")
							submitButton.removeClass("loading")
							return
						}

						me.submitOrder(false, res.id);
					} else {
						console.error("Error", res)
						errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
						errorView.removeClass("d-none")
						submitButton.removeClass("loading")
					}
				}).fail((xhr, status, error) => {
					console.log(status, error)
					submitButton.removeClass("loading")
				})
			}
		})
	}

	collectFormValuesNAB(formId) {
		const form = document.querySelector(formId);
		if (!form) {
			console.error(`Form not found with ID: ${formId}`);
			return {};
		}

		const formData = new FormData(form);
		const values = {};

		formData.forEach((value, key) => {
			values[key] = value.trim();
		});

		const expMonth = document.getElementById("expMonth");
		const expYear = document.getElementById("expYear");
		if (expMonth && expYear) {
			values.expMonth = expMonth.value;
			values.expYear = expYear.value;
		}

		return values;
	}


	setupAdyen() {
		this.loadingPaymentProvider = true

		jQuery(this.checkoutWrapper).find(".payment-form-error").hide()

		if (!this.hasSetupPaymentProvider) {
			jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").show()
		}

		if (!this.hasInjectedPaymentScript) {
			const scriptCallback = () => {
				this.hasInjectedPaymentScript = true
				this.setupAdyen()
			}

			const styleCallback = () => {
				this.hasInjectedPaymentStyles = true
			}

			var urlBase = "https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/"
			if (!this.useTestPayments) {
				urlBase = "https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/"
			}

			if (!this.scriptInjectState) {
				this.scriptInjectState = this.scriptInjector.inject("script", `${urlBase}${this.AdyenVersion}/adyen.js`, "firehawk-adyen", scriptCallback)
			}

			if (!this.styleInjectState) {
				this.styleInjectState = this.scriptInjector.inject("style", `${urlBase}${this.AdyenVersion}/adyen.css`, "firehawk-adyen", styleCallback)
			}
			return
		}

		let params = {
			paymentProvider: "adyen"
		};

		if (this.cartId && this.cartId.length) {
			params.cart = this.cartId
		}

		if (this.useTestPayments) {
			params.testPayment = true;
		}

		if (this.channel) {
			params.channel = this.channel
		}

		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'fh_pay_intent',
				params: params
			}
		}).done((response) => {
			let paymentIntentRes = JSON.parse(response);
			if (paymentIntentRes && paymentIntentRes.result && paymentIntentRes.result.id) {
				this.paymentIntent = paymentIntentRes.result;
				this.paymentIntentEntityId = paymentIntentRes.paymentEntityId
				this.hasRetriedIntent = false
				this.hasRetriedSetup = false
				this.configureAdyen(this.paymentIntent)
			} else if (!this.hasRetriedIntent) {
				this.hasRetriedIntent = true;
				this.setupAdyen()
			} else {
				jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").hide()
				jQuery(this.checkoutWrapper).find("#fh-payment-details").hide()
				jQuery(this.checkoutWrapper).find(".payment-form-error").show()
			}
			this.loadingPaymentProvider = false
		}).fail((xhr, status, error) => {
			console.log(status, error)
			this.loadingPaymentProvider = false

			if (!this.hasRetriedIntent) {
				this.hasRetriedIntent = true;
				this.setupAdyen()
				return
			}
			jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").hide()
			jQuery(this.checkoutWrapper).find("#fh-payment-details").hide()
			jQuery(this.checkoutWrapper).find(".payment-form-error").show()
		}).always(() => {
			this.isRefreshingPaymentForm = false;
		})
	}

	configureAdyen(paymentIntent) {
		jQuery(this.checkoutWrapper).find(".payment-form-error").hide()

		this.paymentIntent = paymentIntent

		var me = this
		const configuration = {
			environment: this.useTestPayments ? "test" : 'live',
			clientKey: this.paymentProviderApiKey || this.adyenClientKey,
			analytics: {
				enabled: true
			},
			session: {
				id: paymentIntent.id,
				sessionData: paymentIntent.sessionData
			},
			beforeSubmit: (data, component, actions) => {
				jQuery(this.checkoutWrapper).find("#submit-error").addClass("d-none")

				let formValid = me.checkFormValid();
				if (formValid) {
					actions.resolve(data)
				} else {
					actions.reject()
				}
			},
			onPaymentCompleted: (result, component) => {
				var errorView = jQuery(this.checkoutWrapper).find("#payment-error")
				errorView.html("")
				errorView.addClass("d-none")
				me.onAdyenPaymentSuccess()
			},
			onPaymentFailed: (result, component) => {
				var errorView = jQuery(this.checkoutWrapper).find("#payment-error")
				if (result?.resultCode == "Refused") {
					errorView.html("Payment has been refused due to an error. Please check your card details and try again.")
				} else if (result?.resultCode == "Cancelled") {
					errorView.html("Payment has been cancelled due to an error. Please check your card details and try again.")
				} else if (result?.resultCode == "Error") {
					errorView.html("Failed to process payment due to unknown error. Please check your card details and try again.")
				}


				let errorMessage = result?.message || null;
				errorView.removeClass("d-none");
				component.setStatus('ready');
				// this.configureAdyen(this.paymentIntent);
				this.logCheckoutError(`onPaymentFailed Hit. Result code: ${result?.resultCode || "Unknown"}. Message: ${errorMessage || "Unknown"}`);
			},
			onError: (error, component) => {
				if (this.submittingOrder) return;
				console.error(error.name, error.message, error.stack, component);
				var errorView = jQuery(this.checkoutWrapper).find("#payment-error")
				errorView.html("Failed to process payment due to unknown error. Please contact us if you wish to continue your purchase.");
				errorView.removeClass("d-none");
				this.configureAdyen(this.paymentIntent);
				this.logCheckoutError(`onError Hit. Message: ${error.message || "Unknown Error"}`);
			}
		}

		AdyenWeb.AdyenCheckout(configuration).then((checkout) => {
			this.adyenCheckout = checkout
			if (this.adyenDropinComponent) checkout.remove(this.adyenDropinComponent);
			this.adyenDropinComponent = new AdyenWeb.Dropin(checkout, {
				onAdditionalDetails: (state, component, actions) => {
					if (state && state.data && state.data.details && state.data.details.threeDSResult) {
						me.checkAdyen3dsReults(state.data.details.threeDSResult, actions)
					}
					//  else {
					// 	me.updatePaymentPlan(me.paymentPlanSelected)
					// }
				},
				paymentMethodsConfiguration: {
					card: {
						hasHolderName: true,
						holderNameRequired: true,
						billingAddressRequired: false
					}
				}
			}).mount('#fh-payment-details');
			this.hasSetupPaymentProvider = true
			this.loadingPaymentProvider = false
			jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").hide()
			jQuery(this.checkoutWrapper).find("#fh-payment-details").show()

		}).catch(error => {
			console.log(error)
			this.loadingPaymentProvider = false
			if (!this.hasRetriedSetup && this.paymentIntent) {
				this.hasRetriedSetup = true;
				this.configureAdyen(this.paymentIntent)
				return
			}

			jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").hide()
			jQuery(this.checkoutWrapper).find("#fh-payment-details").hide()
			jQuery(this.checkoutWrapper).find(".payment-form-error").show()
		})
	}

	onAdyenOrderSubmitted() {
		if (this.useCustomConfirmationPage) {
			this.checkoutComplete = true;
			var redirectUrl = window.location.origin + "/confirmation?cart=" + this.cartId
			if (this.successRedirectUrl) {
				redirectUrl = this.mergeTags(this.successRedirectUrl, { cart: this.cartId })
			}

			window.location.replace(redirectUrl);
		} else {
			this.checkoutComplete = true;
			jQuery(this.checkoutWrapper).find(".fh-info-col").hide()
			jQuery(this.checkoutWrapper).find(".fh-payment-info-wrapper").hide()
			jQuery(this.checkoutWrapper).find("#fh-payment-success-message").show()
			jQuery(this.checkoutWrapper).find(".firehawk-pay").hide()
			jQuery(this.checkoutWrapper).trigger("fh-cart:checkout-complete");
		}
	}

	onAdyenPaymentSuccess() {
		if (this.submittingOrder) return
		this.submittingOrder = true
		this.paymentFormComplete = true

		var submitButton = jQuery(this.checkoutWrapper).find("#submit-order")
		var errorView = jQuery(this.checkoutWrapper).find("#submit-error")

		jQuery(this.checkoutWrapper).find(".fh-checkout-loading-overlay").show()
		jQuery(this.checkoutWrapper).addClass("loading")

		const wrapperEl = jQuery(this.checkoutWrapper)[0];
		if (wrapperEl?.scrollIntoView) {
			wrapperEl.scrollIntoView({ behavior: "smooth" });
		}

		let shippingFirstName = jQuery(this.checkoutWrapper).find('input[name="shippingFirstName"]').val()
		let shippingLastName = jQuery(this.checkoutWrapper).find('input[name="shippingLastName"]').val()
		let shippingCompany = jQuery(this.checkoutWrapper).find('input[name="shippingCompany"]').val()
		let shippingStreet = jQuery(this.checkoutWrapper).find('input[name="shippingStreet"]').val()
		let shippingCity = jQuery(this.checkoutWrapper).find('input[name="shippingCity"]').val()
		let shippingPickerState = jQuery(this.checkoutWrapper).find('select[name="shippingState"]').val()
		let shippingFieldState = jQuery(this.checkoutWrapper).find('input[name="shippingState"]').val()
		let shippingCounty = jQuery(this.checkoutWrapper).find('input[name="shippingCounty"]').val()
		let shippingCountry = jQuery(this.checkoutWrapper).find('select[name="shippingCountry"]').val()
		let shippingPostcode = jQuery(this.checkoutWrapper).find('input[name="shippingPostcode"]').val()
		let shippingEmail = jQuery(this.checkoutWrapper).find('input[name="shippingEmail"]').val()
		let shippingPhone = jQuery(this.checkoutWrapper).find('input[name="shippingPhone"]').val()

		let depositAmount = jQuery(this.checkoutWrapper).find('input[name="depositAmount"]').val()
		let instalmentOption = jQuery(this.checkoutWrapper).find('input[name="paymentPlanInstalmentOption"]:checked').val()

		let params = {
			cart: this.cartId,
			cartCurrency: this.cartCurrency || null,
			orderDetails: {
				shippingFirstName: shippingFirstName || null,
				shippingLastName: shippingLastName || null,
				shippingCompany: shippingCompany || null,
				shippingStreet: shippingStreet || null,
				shippingCity: shippingCity || null,
				shippingState: shippingPickerState || shippingFieldState || null,
				shippingCounty: shippingCounty || null,
				shippingCountry: shippingCountry || null,
				shippingPostcode: shippingPostcode || null,
				shippingEmail: shippingEmail || null,
				shippingPhone: shippingPhone || null
			},
			paymentIntent: this.paymentIntent || null,
			paymentProvider: this.paymentProvider || null,
			paymentEntityId: this.paymentIntentEntityId || null
		};

		if (this.payByInstallments) {
			params.orderDetails.instalmentOption = instalmentOption || null
			params.orderDetails.depositAmount = depositAmount || null
		}

		let requestParams = {
			method: 'POST',
			url: ajax_var.url,
			timeout: 180 * 1000,
			data: {
				action: 'submit_order',
				params: params
			}
		}

		const successHandler = (res) => {
			if (res && res.result) {
				this.onAdyenOrderSubmitted()

				if (!this.useCustomConfirmationPage) {
					jQuery(this.checkoutWrapper).removeClass("loading")
					jQuery(this.checkoutWrapper).find(".fh-checkout-loading-overlay").hide()
					submitButton.removeClass("loading")
				}
			} else {
				jQuery(this.checkoutWrapper).removeClass("loading")
				jQuery(this.checkoutWrapper).find(".fh-checkout-loading-overlay").hide()
				submitButton.removeClass("loading");
				this.logCheckoutError(`onAdyenPaymentSuccess failed with no results`);
			}

			this.submittingOrder = false;
		};

		const errorHandler = (xhr, status, error) => {
			console.log("errorHandler", xhr, status, error);
			
			this.isSubmitting = false
			this.paymentFormComplete = true
			this.submittingOrder = false;
			jQuery(this.checkoutWrapper).removeClass("loading")
			jQuery(this.checkoutWrapper).find(".fh-checkout-loading-overlay").hide()

			this.logCheckoutError(`onAdyenPaymentSuccess Failed. Message: ${error.message || "Unknown Error"}`);

			errorView.html("Something has gone wrong. Please try again or contact us if the issue persists.")
			errorView.removeClass("d-none")
			submitButton.removeClass("loading")
		};

		this.ajaxWithRetry(requestParams, 3, 2000, successHandler, errorHandler)
	}

	ajaxWithRetry(params, retries, delay, onSuccess, onFailed) {
		let me = this;
		jQuery.ajax({
			...params,
			success: function(response) {
				if (!response || Object.keys(response).length == 0) {
					if (retries > 0) {
						me.ajaxWithRetry(params, retries - 1, delay * 2, onSuccess, onFailed);
					} else {
						if (onFailed) onFailed(null, 400, "No response");
					}
				} else {
					if (onSuccess) onSuccess(response);
				}
			},
			error: function(xhr, status, error) {
				if (retries > 0) {
					setTimeout(() => {
						me.ajaxWithRetry(params, retries - 1, delay * 2, onSuccess, onFailed);
					}, delay);
				} else {
					console.error('Failed after retries');
					if (onFailed) onFailed(xhr, status, error);
				}
			}
		});
	}

	checkAdyen3dsReults(reference, responseActions) {
		let me = this

		let params = {
			reference: reference,
			cart: this.cartId,
		}

		if (this.paymentProviderApiKey && this.paymentProviderApiKey.length) {
			params.customStripe = true;
		}

		if (this.useTestPayments) {
			params.testPayment = true
		}

		let errorView = jQuery(this.checkoutWrapper).find("#submit-error")

		let requestParams = {
			method: 'post',
			url: ajax_var.url,
			timeout: 300,
			data: {
				action: 'fh_pay_check_3ds',
				params: params
			}
		}

		const successHandler = (response) => {
			if (response.resultCode && responseActions) {
				responseActions.resolve({ resultCode: response.resultCode });
			} else if (response.success) {
				me.onAdyenPaymentSuccess()
			} else {
				//handle error
				let message = response.message || "3ds Authentication failed, please try again or switch payment methods."
				errorView.html(message)
				errorView.removeClass("d-none")
				me.updatePaymentPlan(me.paymentPlanSelected)
			}
		};

		const errorHandler = (xhr, status, error) => {
			//handle error
			let message = "3ds Authentication failed, please try again or switch payment methods."
			errorView.html(message)
			errorView.removeClass("d-none")
			me.updatePaymentPlan(me.paymentPlanSelected)
		};

		ajaxWithRetry(requestParams, 3, 2000, successHandler, errorHandler);
	}

	openInstallmentsSetupModal(paymentIntent) {
		let modalContainer = jQuery(this.checkoutWrapper)
		let modal = new FirehawkCheckoutDDModal(paymentIntent, { useTestPayments: this.useTestPayments, paymentProviderApiKey: this.paymentProviderApiKey, adyenClientKey: this.adyenClientKey, container: modalContainer })
		modal.show()
	}

	paymentSuccessRedirect(response) {
		jQuery(this.checkoutWrapper).trigger("fh-cart:checkout-complete");

		if (this.successNoRedirect) {
			// DO NOTHING - Handled elswhere
		} else if (this.useCustomConfirmationPage) {
			var redirectUrl = window.location.origin + "/confirmation?cart=" + this.cartId
			if (this.successRedirectUrl) {
				redirectUrl = this.mergeTags(this.successRedirectUrl, { cart: this.cartId })
			}

			window.location.replace(redirectUrl);
		} else if (this.successRedirectUrl) {
			window.location.replace(this.successRedirectUrl);
		} else if (response && response.result) {
			if (response.result.invoiceId) {
				window.location.replace(window.location.origin + "/confirmation?invoice=" + response.result.invoiceId);
			} else if (response.result.orderId) {
				window.location.replace(window.location.origin + "/confirmation?order=" + response.result.orderId);
			} else if (response.result.quoteId) {
				window.location.replace(window.location.origin + "/confirmation?plan=" + response.result.quoteId);
			} else {
				window.location.replace(window.location.origin + "/confirmation");
			}
		}
	}

	setupStripe() {
		this.loadingPaymentProvider = true

		if (!this.hasSetupPaymentProvider) {
			jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").show()
		}

		// let testStripe = "pk_test_51HyO42F2bX2kTVtibwiGBRz0NODYQAkYYlr0eDT34Jle6i3AQZQ2Q9ClTf455EDVfatn9AvmQG3cbaKfDlmwputC00i1vFVPWD";
		let liveStripeAu = "pk_live_51HyO42F2bX2kTVtiLQbImMOe6VW5pIFd2mIRJ0SdYMvrSRa7BvaWvwr46hlOMP6GPPe0wX0oInJXLQkIcfBXMsPE00xgM7qEgI";
		let liveStripeUsd = "pk_live_51KyUfFL6cJQBjiCc0VN2wKDAT7SjjAYBRl1ho1o9Lg6b7dFwyM61lDpk9RI3NTimppdOCtBlrP4IbY4ehk9nybzU005ECfSwQ8";
		let testStripeAu = "pk_test_51HyO42F2bX2kTVtibwiGBRz0NODYQAkYYlr0eDT34Jle6i3AQZQ2Q9ClTf455EDVfatn9AvmQG3cbaKfDlmwputC00i1vFVPWD";
		let testStripeUsd = "pk_test_51KyUfFL6cJQBjiCccmZRdC9aCebmimF8uQkEbVKlKJay9YdGL2vJtSiTUFOOpcS7PlMsHFIPCBFKpw3cIWO5mYkg0086sV4c5D";
		let liveStripe = null;
		if (this.cartCurrency == "usd") {
			if (this.useTestPayments) {
				liveStripe = testStripeUsd;
			} else {
				liveStripe = liveStripeUsd;
			}
		} else if (this.cartCurrency == "aud") {
			if (this.useTestPayments) {
				liveStripe = testStripeAu;
			} else {
				liveStripe = liveStripeAu;
			}
		}

		let stripeKey = liveStripe;
		let customStripe = false;

		if (this.paymentProviderApiKey && this.paymentProviderApiKey.length) {
			stripeKey = this.paymentProviderApiKey;
			customStripe = true;
		}

		this.stripe = Stripe(stripeKey);

		let params = {
			customStripe: customStripe
		};

		if (this.cartId && this.cartId.length) {
			params.cart = this.cartId
		}

		if (this.useTestPayments) {
			params.testPayment = true;
		}

		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'fh_pay_intent',
				params: params
			}
		}).done((response) => {
			let paymentIntentRes = JSON.parse(response);
			if (paymentIntentRes && paymentIntentRes.result && paymentIntentRes.result.client_secret) {
				this.paymentIntent = paymentIntentRes.result;
				this.elements = this.stripe.elements({
					clientSecret: this.paymentIntent.client_secret,
				});

				this.paymentElement = this.elements.create('payment');
				this.paymentElement.mount('#fh-payment-details');

				this.paymentElement.on('change', (event) => {
					this.paymentFormComplete = event.complete
				});

				this.hasSetupPaymentProvider = true
				jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").hide()
				jQuery(this.checkoutWrapper).find("#fh-payment-details").show()

			}
			this.loadingPaymentProvider = false
		}).fail((xhr, status, error) => {
			console.log(status, error)
			this.loadingPaymentProvider = false
			jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").hide()
		})
	}

	updateShippingMethod(shippingMethod) {
		if (this.submittingOrder) return;

		var params = {
			shippingMethod: shippingMethod
		};

		if (this.cartId) {
			params.cart = this.cartId
		}

		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'update_shipping_method',
				params: params
			}
		}).done((response) => {
			var data = JSON.parse(response);
			if (data && data.result && data.result.cart) {
				let subtotal = data.result.cart.subtotal || 0
				let tax = data.result.cart.tax || 0
				let total = data.result.cart.total || 0
				let shipping = data.result.cart.shipping || 0
				jQuery(this.checkoutWrapper).find('#fh-cart-balance-shipping').html(shipping)
				jQuery(this.checkoutWrapper).find('#fh-cart-stock-balance-subtotal').html(subtotal)
				jQuery(this.checkoutWrapper).find('#fh-cart-stock-balance-tax').html(tax)
				jQuery(this.checkoutWrapper).find('#fh-cart-stock-balance-total').html(total)
				
				this.refreshPaymentForm();
			}
		}).fail(() => {

		})
	}

	updatePaymentMethod(paymentMethod) {
		this.paymentMethod = paymentMethod
		if (paymentMethod == "firehawk-pay") {
			jQuery(this.checkoutWrapper).find(".firehawk-pay").show()
		} else if (paymentMethod == "blink-payments") {
			jQuery(this.checkoutWrapper).find(".blink-payments").show()
		} else {
			jQuery(this.checkoutWrapper).find(".firehawk-pay").hide()
		}
	}

	updatePaymentPlan(paymentPlanSelected) {
		this.paymentPlanSelected = paymentPlanSelected
		console.log(this.paymentPlans)

		// if(this.paymentPlanSelected == "in-full") {
		// 	this.setupAdyen();
		// }

		let instalmentSection = jQuery(this.checkoutWrapper).find(".fh-instalment-wrapper");
		let depositSection = jQuery(this.checkoutWrapper).find(".fh-deposit-wrapper");
		let depositAmountSection = jQuery(this.checkoutWrapper).find(".fh-deposit-amount-wrapper");
		let paymentBreakdownWrapper = jQuery(this.checkoutWrapper).find(".fh-payment-amount-breakdown-wrapper");
		let paymentMethodsWrapper = jQuery(this.checkoutWrapper).find(".fh-payment-methods-wrapper");

		let selectedPlan = null;
		if (this.paymentPlanSelected && this.paymentPlanSelected.length) {
			selectedPlan = this.paymentPlans.find((p) => p.slug == this.paymentPlanSelected)
		}

		if (selectedPlan && selectedPlan.instalmentOptions && selectedPlan.instalmentOptions.length) {
			instalmentSection.show();
			depositSection.show();
			if (this.planDepositDisplay == "yes") {
				depositAmountSection.show();
			}
			paymentBreakdownWrapper.show();
			paymentMethodsWrapper.hide()
			this.payByInstallments = true
			this.runUpdateInstalments();
		} else {
			this.payByInstallments = false
			instalmentSection.hide();
			depositSection.hide();
			depositAmountSection.hide();
			paymentBreakdownWrapper.hide();
			paymentMethodsWrapper.show()

			jQuery(this.checkoutWrapper).find("#fh-payment-details").hide()
			jQuery(this.checkoutWrapper).find("#fh-payment-details").html("")
			jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").show()

			if (this.hasInjectedPaymentScript) {
				this.setupAdyen()
			}
		}
	}

	updatePaymentPlanDepositDisplay(optionSelected) {
		this.planDepositDisplay = optionSelected
		let depositAmountSection = jQuery(this.checkoutWrapper).find(".fh-deposit-amount-wrapper");

		if (optionSelected == "yes") {
			depositAmountSection.show();
		} else {
			depositAmountSection.hide();
		}
		this.runUpdateInstalments();
	}

	updatePaymentInstalment(optionSelected) {
		this.runUpdateInstalments();
	}

	runUpdateInstalments() {
		if (this.submittingOrder) return;
		jQuery(this.checkoutWrapper).find("#fh-payment-details").hide()
		jQuery(this.checkoutWrapper).find("#fh-payment-details").html("")
		jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").show()

		let depositAmount = jQuery(this.checkoutWrapper).find('input[name="depositAmount"]').val()
		let instalmentOption = jQuery(this.checkoutWrapper).find('input[name="paymentPlanInstalmentOption"]:checked').val()

		let params = {
			paymentProvider: "adyen"
		};

		if (this.cartId && this.cartId.length) {
			params.cart = this.cartId
		}

		if (depositAmount) {
			params.deposit_amount = depositAmount
		}

		if (instalmentOption) {
			params.instalmentOption = instalmentOption
		}

		if (this.useTestPayments) {
			params.testPayment = true;
		}

		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'fh_pay_instalment_amount',
				params: params
			}
		}).done((response) => {
			var data = JSON.parse(response);
			let paymentBreakdownWrapper = jQuery(this.checkoutWrapper).find(".fh-payment-amount-breakdown-wrapper");
			if (data && data.result) {
				jQuery(this.checkoutWrapper).find('#paymentInstalmentToday').html(data.result.firstInstalmentAmount || "Error")
				jQuery(this.checkoutWrapper).find('#paymentBreakdownInstalment').html(data.result.remainingInstalmentAmounts || "Error")
				jQuery(this.checkoutWrapper).find('#grandTotalPayable').html(data.result.grandTotalPayable || "Error")
				jQuery(this.checkoutWrapper).find("#upcoming-payments-col-1").empty();
				jQuery(this.checkoutWrapper).find("#upcoming-payments-col-2").empty();

				if (data.result.adminFee) {
					jQuery(this.checkoutWrapper).find('#paymentInstalmentAdminFee').html(` (incl. ${data.result.adminFee} admin fee)`);
				} else {
					jQuery(this.checkoutWrapper).find('#paymentInstalmentAdminFee').empty();
				}
				
				if (data.result.instalmentPaymentDates && data.result.instalmentPaymentDates.length) {
					let paymentInstalmentLength = data.result.instalmentPaymentDates.length;
					let halfway = Math.ceil(paymentInstalmentLength / 2);
					for (let i = 0; i < data.result.instalmentPaymentDates.length; i++) {
						const el = data.result.instalmentPaymentDates[i];
						if (i < halfway) {
							jQuery(this.checkoutWrapper).find("#upcoming-payments-col-1").append(`<div class="list-group-item upcoming d-flex align-items-center justify-content-between">Instalment ${el}: ${data.result.remainingInstalmentAmounts || "Error"}</div>`)
						} else {
							jQuery(this.checkoutWrapper).find("#upcoming-payments-col-2").append(`<div class="list-group-item upcoming d-flex align-items-center justify-content-between">Instalment ${el}: ${data.result.remainingInstalmentAmounts || "Error"}</div>`)
						}
					}
					if (paymentInstalmentLength % 2 > 0) {
						jQuery(this.checkoutWrapper).find("#upcoming-payments-col-2").append(`<div class="list-group-item upcoming d-flex align-items-center justify-content-between" style="height: 100%;"></div>`)
					}
				}
				paymentBreakdownWrapper.show();
				if (data.result.paymentIntent) {
					this.configureAdyen(data.result.paymentIntent)
				}
			} else {
				paymentBreakdownWrapper.hide();
			}

			jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").hide()
			jQuery(this.checkoutWrapper).find("#fh-payment-details").show()
		}).fail((xhr, status, error) => {
			console.log(status, error)
			jQuery(this.checkoutWrapper).find(".payment-loading-placeholder").hide()
			jQuery(this.checkoutWrapper).find("#fh-payment-details").hide()
		})
	}

	observeAdyenCheckout() {
		var me = this
		const observer = new PerformanceObserver((list) => {
			for (const entry of list.getEntries()) {
				if (entry.initiatorType === "fetch") {
					var hasSubmitted = me.checkDDSubmission(entry.name)

					if (hasSubmitted && !me.paymentFormComplete) {
						me.onAdyenPaymentSuccess()
					}
				}
			}
		});

		observer.observe({
			entryTypes: ["resource"]
		});

		this.requestObserver = observer
	}

	checkDDSubmission(entryName) {
		if (!this.paymentIntent || !this.payByInstallments) return

		var urlBase = "https://checkoutshopper-test.adyen.com/checkoutshopper/v1"
		if (!this.useTestPayments) {
			urlBase = "https://checkoutshopper-live.adyen.com/checkoutshopper/v1"
		}

		var requestUrl = `${urlBase}/sessions/${this.paymentIntent.id}/payments?clientKey=${this.paymentProviderApiKey}`
		if (requestUrl == entryName) {
			return true
		} else {
			return false
		}
	}

	mergeTags(content, data, useFlatten = false) {
		var newContent = content
		var tags = newContent.match(/\{}*\{.*?\}\}/g);
		if (tags && tags.length > 0) {
			tags.forEach(tag => {
				var replaced = tag.replace(/[\{\}']+/g, '').trim()
				var keys = useFlatten ? replaced : replaced.split('.')
				var value = data ? lodash.get(data, keys) || '' : ''
				newContent = newContent.replace(tag, value)
			})
		}

		return newContent
	}

	logCheckoutError(message) {
		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'log_checkout_error',
				message: message
			}
		}).done(() => {

		}).fail(() => {
			
		})
	}
}
